import React from "react";

function Data_Warehouse() {
  return (
    <div className="courseData">
      <div className="container">
        <div className="row">
          <div className="course_details_heading">
            <h1>RHCE Certification</h1>
          </div>
          <div className="imgSection">
            <img
              src={require("../../../images/courses/rhcsa-img-500x262.png")}
              alt=""
            />
          </div>
          <div className="heading">
            <h3>RHCE Certification</h3>
            <p>
              RHCE Certification is reputed lab based exam conducted by Red Hat.
              Focus Training services is authorized exam center that conducts
              the exam for RHCE Pune India.
            </p>

            <p style={{ textAlign: "center", fontWeight: "bold" }}>
              RED HAT SYSTEM ADMINISTRATION III (RH 254) – RHCE Certification{" "}
              <br />
              RED HAT CERTIFIED ENGINEER – RHCE Pune India
            </p>

            {/*  */}

            <h4>SKILLSET AFTER EARNING THE CERTIFICATION</h4>
            <ul>
              <li>
                Configuring static routes, packet filtering, and network address
                translation{" "}
              </li>
              <li>Setting kernel runtime parameters </li>
              <li>
                Configuring an Internet Small Computer System Interface (iSCSI)
                initiator{" "}
              </li>
              <li>Producing and delivering reports on system utilization</li>
              <li>
                Using shell scripting to automate system maintenance tasks{" "}
              </li>
              <li>Configuring system logging, including remote logging </li>
              <li>
                Configuring a system to provide networking services, including
                HTTP/HTTPS, File Transfer Protocol (FTP), network file system
                (NFS), server message block (SMB), Simple Mail Transfer Protocol
                (SMTP), secure shell (SSH) and Network Time Protocol (NTP){" "}
              </li>
            </ul>

            {/*  */}
            <h4>ELIGIBILITY</h4>
            <ul>
              <li>RHCSAs who wish to earn a more senior-level credential. </li>
              <li>
                Experienced senior system administrators who have not yet
                certified.{" "}
              </li>
              <li>
                Course participants in Red Hat Training who have completed
                System Administration I, II, and II, or who have completed the
                RHCE Rapid Track Course.
              </li>
              <li>
                Experienced system administrators who require certification for
                their job or by mandate (e.g., US Department of Defense
                Directive 8570).{" "}
              </li>
            </ul>

            <h4>EXAM CODE</h4>
            <p style={{ textAlign: "center", fontWeight: "bold" }}>
              EX300 – RHCE Certification- Red Hat Certified Engineer (RHCE 7)
              exam at Focus Pune India.
            </p>

            {/*  */}
            <h4>COURSE CONTENT for RHCE Pune India.</h4>
            <ul>
              <li>Review how to manage services and the boot-up process using systemctl.Manage IPv6 networking </li>
              <li>Configure and troubleshoot basic IPv6 networking on Red Hat Enterprise Linux systems. Configure link aggregation and bridging </li>
              <li>Configure and troubleshoot advanced network interface functionality including bonding, teaming, and local software bridges.Control network port security</li>
              <li>Permit and reject access to network services using advanced SELinux and firewalld filtering techniques.Manage DNS for servers </li>
              <li>Set and verify correct DNS records for systems and configure secure DNS caching.Configure email delivery </li>
              <li>Relay all email sent by the system to an SMTP gateway for central delivery. Provide block-based storage </li>
              <li>Provide and use networked iSCSI block devices as remote disks. Provide file-based storage </li>
              <li>Provide NFS exports and SMB file shares to specific systems and users. Configure MariaDB databases </li>
              <li>Provide a MariaDB SQL database for use by programs and database administrators.Provide Apache HTTPD web service </li>
              <li>Configure Apache HTTPD to provide Transport Layer Security (TLS)-enabled websites and virtual hosts.Write Bash scripts </li>
              <li>Write simple shell scripts using Bash.Bash conditionals and control structures </li>
              <li>Use Bash conditionals and other control structures to write more sophisticated shell commands and scripts.Configure the shell environment </li>
              <li>Customize Bash startup and use environment variables, Bash aliases, and Bash functions.Linux containers preview </li>
              <li>Preview the capabilities of Linux containers, Docker, and other related technologies in Red Hat Enterprise Linux 7.Comprehensive review </li>
              <li>Practice and demonstrate knowledge and skills learned in Red Hat System Administration III. </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Data_Warehouse;
